import { __assign, __rest } from "tslib";
import React from 'react';
import { transformWireframeProps } from '../../../../utils/propUtils';
import VeltCommentDialogAgentSuggestionActionAcceptWireframe from './VeltCommentDialogAgentSuggestionActionAcceptWireframe/VeltCommentDialogAgentSuggestionActionAcceptWireframe';
import VeltCommentDialogAgentSuggestionActionRejectWireframe from './VeltCommentDialogAgentSuggestionActionRejectWireframe/VeltCommentDialogAgentSuggestionActionRejectWireframe';
var VeltCommentDialogAgentSuggestionActionsWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comment-dialog-agent-suggestion-actions-wireframe", __assign({}, transformedProps), children));
};
VeltCommentDialogAgentSuggestionActionsWireframe.Accept = VeltCommentDialogAgentSuggestionActionAcceptWireframe;
VeltCommentDialogAgentSuggestionActionsWireframe.Reject = VeltCommentDialogAgentSuggestionActionRejectWireframe;
export default VeltCommentDialogAgentSuggestionActionsWireframe;
